























































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

import moment from 'moment';

@Component({
    components: {

    }
}) export default class NoticeDetail extends Mixins(VueHoduCommon) {

    /**
     * 공지사항 HTML 테스트 및 디자이너 작성용
     */
    hodu_html : string = `
        <div class="noti_1" style="max-width:600px; width:100%; margin: 0 auto;">
            <img style="max-width: 600px; width:100%; display:block;margin:0 0 40px;" src="${require('../assets/images/ware/noti_img/nImg_0.png')}"  alt="hodu calendar app" />
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:30px;font-size:13px; margin-bottom:30px;color:#232848; display:block; width:100%; box-sizing:border-box; font-size:15px">
                2020년을 새롭게 장식할 호두 ver 5.0.1<br>
                오랫동안 기다려주신 사용자 분들께 감사한 말씀과 함께<br>
                새롭게 리뉴얼한 호두앱에 대해 소개해 드리려 합니다.
            </p>
            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px; display:block; width:100%; box-sizing:border-box;">1. 달력 디스플레이 옵션</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px; display:block; width:100%; box-sizing:border-box;">
                모든 사용자가 원하는 달력이 다르다는 걸 알기에<br>
                새 호두는 두 가지의 옵션을 여러분께 제공합니다.
                <span style="display:block; margin-bottom:15px;"></span>
                월 별 일정을 간단히 보고싶다면 VERSION 1 추천,<br>
                주 별로 자세히 일정을 확인하고 싶다면 VERSION 2 추천!
            </p>
            <img style="max-width: 600px; width:100%; display:block;margin:0 0 60px;" src="${require('../assets/images/ware/noti_img/nImg_1.png')}"  alt="1번 설명 이미지" />

            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">2. 외부달력 연동 지원</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                그 동안 외부달력이랑 연동이 안되어서 힘드셨죠? :(<br>
                이번 버전에서 여러분을 위해 준비하였습니다.
                <span style="display:block; margin-bottom:15px;"></span>
                다른 캘린더앱과 연동하여 앱 하나로<br>
                더 편리하게 일정 관리를 시작하세요!
            </p>
            
            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">3. 할일(TO-DO) 기능</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                “내일 카드 정지하고, 세탁소 갔다가 저녁 준비 해야하는데...<br>
                하나라도 잊어버리면 어쩌지...”
                <span style="display:block; margin-bottom:15px;"></span>
                할 일 등록부터 진행 & 완료된 할 일 까지 한번에 가능<br>
                새 호두에서 꼭 활용해보세요!
            </p>
            <img style="max-width: 600px; width:100%; display:block;margin:0 0 60px;" src="${require('../assets/images/ware/noti_img/nImg_2.png')}"  alt="3번 설명 이미지" />
            
            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">4. 여러 개의 알림 설정 </p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                일정 3시간 전 "이제 일어나 볼까?" <br>
                일정 1시간 전 "이제 씻어야지~" <br>
                일정 30분 전 "준비완료! 출발~"
                <span style="display:block; margin-bottom:15px;"></span>
                한번으론 기억하기 어려운 일정! <br>
                여러 번의 알림으로 일정을 놓치지 마세요!
            </p>
            
            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">5. 여러 개의 주소 추가</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                오늘은 김호두 생일! <br>
                빵집에 가서 케이크를 사고, 백화점에서 선물을 픽업 후<br>
                광화문 생일파티 장소로 고고~
                <span style="display:block; margin-bottom:15px;"></span>
                한 일정 속 장소 이동이 많다면 여러 개의 일정보다 <br>
                주소 추가 기능을 활용해보세요!
            </p>

            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">6. 길 찾기</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                약속 장소 일일이 찾아다니기 너무 힘드시죠? :( <br>
                이제 클릭 한번으로 찾아가세요!
                <span style="display:block; margin-bottom:15px;"></span>
                자가용을 사용하는 당신에겐 자동차 네비게이션을, <br>
                대중교통을 사용하는 당신에겐 어플 지도를!
            </p>
            <img style="max-width: 600px; width:100%; display:block;margin:0 0 60px;" src="${require('../assets/images/ware/noti_img/nImg_3.png')}"  alt="6번 설명 이미지" />

            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">7. 일정 등록 중, 등록 후 공유</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                일정 등록 중 또는 등록 후에도 공유가 쉬워집니다.
                <span style="display:block; margin-bottom:15px;"></span>
                등록 중 호두 친구 (연락처)와 속한 그룹&팀에 공유가 가능하며,<br> 
                등록 후 위와 더불어 문자메세지, 카톡으로도 공유가 가능합니다.
            </p>

            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">8. 강력한 검색 기능</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                "AND"와 "OR" 검색을 알고계신가요? <br>
                이 두 기능만 알고계시면 일정검색이 훨씬 쉬워집니다.
                <span style="display:block; margin-bottom:15px;"></span>
                아래 예제로 지금 알아볼까요?
            </p>

            <img style="max-width: 600px; width:100%; display:block;margin:0 0 60px;" src="${require('../assets/images/ware/noti_img/nImg_4.png')}"  alt="8번 설명 이미지" />
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px;margin-top:-30px; margin-bottom:50px;">
                "AND"와 "OR" 검색으로 일정 제목만이 아닌 메모, 장소 등<br>
                일정에 포함된 내용까지 통합하여 검색 가능합니다!
            </p>

            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">9. 그룹과 팀</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                소모임부터 기업까지 사용 가능한 호두 그룹과 팀 기능<br>
                그룹(상위)과 팀(하위)을 구분하여 관리가 편해집니다.
            </p>
            <img style="max-width: 600px; width:100%; display:block;margin:0 0 60px;" src="${require('../assets/images/ware/noti_img/nImg_5.png')}"  alt="9번 설명 이미지" />


            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">10. 멤버관리</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                팀장님 : 어제 입사하신 직원 분 호두 등록했나요?<br>
                인사팀 : 네, 가입 승인 처리 완료 했습니다.<br>
                총괄팀 : 그 대리님 직급에 맞추어 권한 부여 완료했습니다.
                <span style="display:block; margin-bottom:15px;"></span>
                일괄적인 권한 설정이 아닌 멤버 개인별로<br>
                권한을 부여하기 때문에 멤버 및 그룹&팀 관리가 쉬어집니다.
            </p>
            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">11. TASK (업무)</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                기본업무, 단계식 업무, 체크식 업무 옵션을 활용해<br>
                업무 특성에 맞추어 등록이 가능합니다.
                <span style="display:block; margin-bottom:15px;"></span>
                업무자 배정, 업무자 현황 파악을 통해 업무능률 향상시키며<br> 
                호두웹과 앱을 통해 업무를 관리하세요.
                <span style="display:block; margin-bottom:15px;"></span>
                (프리미엄 버전 호두C 기능입니다)
            </p>
            <img style="max-width: 600px; width:100%; display:block;margin:0 0 60px;" src="${require('../assets/images/ware/noti_img/nImg_6.png')}"  alt="11번 설명 이미지" />
            

            <p class="title_p" style="padding:0 20px; font-weight:400; font-size: 15px;font-style:normal; display:block; margin-top:40px;">12. 파일보관함</p>
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px; font-size:13px;">
                회사에선...<br>
                인사팀 : 연말정산 자료는 “파일함 A”에 있습니다.<br>
                            다운 받아 작성해 주세요.
                <span style="display:block; margin-bottom:15px;"></span>
                동호회에선...<br>
                동호회장 : 지난 번 여행 사진은 “사진 파일함”에 올렸습니다. <br>
                            다운 받으세요~
                <span style="display:block; margin-bottom:15px;"></span>
                멤버 간 파일 공유? 이렇게 편해집니다!
            </p>
            <img style="max-width: 600px; width:100%; display:block;margin:0 0 60px;" src="${require('../assets/images/ware/noti_img/nImg_7.png')}"  alt="12번 설명 이미지" />
            <hr style="opacity:0.3; margin: 30px 0">
            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px;margin-bottom:10px;">더 자세한 사항은 호두웨어를 방문하셔서, 주요기능과 메뉴얼을 확인해주세요.</p>
            <a style="margin-left:20px;text-decoration: none;display:block;height:30px;margin-bottom:20px; line-height:30px;font-size:14px; font-weight:bold; color:#477fff;" href="https://www.hoduware.com">www.hoduware.com</a>

            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:25px;font-size:13px; margin-bottom:30px;margin-bottom:10px;">궁금하신 사항은 아래 고객센터로 연락 주시기 바랍니다.</p>
            <a style="margin-left:20px;text-decoration: none;display:block;height:30px;margin-bottom:40px; line-height:30px;font-size:14px; font-weight:bold; color:#477fff;" href="mailTo:withforu.co.kr@gmail.com">withforu.co.kr@gmail.com</a>

            <hr style="opacity:0.3; margin: 30px 0">

            <p style="padding:0 20px; color:#647088; font-weight:300; line-height:30px;font-size:15px; margin-bottom:100px;text-align:center;font-weight:bold;">새해에는 항상 행복한 일들만<br>가득하기를 호두가 기원합니다.</p>
        </div>`;

    hodu_notice_list : any[] = [];
    hodu_notice : any;
    noti_uid : string = "";

    index : number = -1;
    
    async mounted() : Promise<void> {
        this.noti_uid = this.$route.params.noti_uid;
        await this.getHoduNoticeList();
    }

    /**
     * 공지사항 리스트로 이동
     */
    goNotice() : void {
        this.$router.push('/notice').catch((e) => {});
    }

    /**
     * 호두 공지사항 리스트 조회
     */
    async getHoduNoticeList() : Promise<void> {
        const vue = this;

        await this.hodu_api_call(`api/v1/hodu/notice?current_date=${moment(new Date()).utc().format()}`, 'get')
            .then(async(response) => {
                console.log(response);
                vue.hodu_notice_list.splice(0, vue.hodu_notice_list.length);
                vue.hodu_notice_list = vue.hodu_notice_list.concat(response.data.data.hodu_notice_list);

                const notice_length : number = vue.hodu_notice_list.length;
                for( let i = 0; i < notice_length; i++) {
                    if( vue.hodu_notice_list[i].noti_uid == vue.noti_uid ) {
                        vue.hodu_notice = vue.hodu_notice_list[i];
                        vue.index = i;
                        return;
                    }
                }

                // 해당하는 공지사항이 없다면
                if( vue.index == -1 ) {
                    alert('공지사항이 존재하지 않습니다');
                    this.$router.push('/notice');
                }
            })
            .catch(async(e) => {
                alert('공지사항 조회 실패');
                this.$router.push('/notice');
            });
    }

    /**
     * 이전버튼 클릭
     */
    clickPrev() : void {
        if( this.index < 1 ) {
            return;
        }

        this.$router.push(`/notice/${this.hodu_notice_list[this.index - 1].noti_uid}`);
    }

    /**
     * 다음버튼 클릭
     */
    clickNext() : void {
        if( this.index >= this.hodu_notice_list.length - 1 ) {
            return;
        }

        this.$router.push(`/notice/${this.hodu_notice_list[this.index + 1].noti_uid}`);
    }

}

